<div *ngIf="exportView" class="export-modal">
    <div (click)="$event.stopPropagation()" style="min-width: fit-content;min-height: fit-content;padding-top: 12px"
        class="modal-card export-card">
        <span *ngIf="url || errorBool" (click)="closeExportWindow()" class="material-icons modal-close-local close-button">
            close
          </span>
        <div>
            <!-- <img width="80px" height="50px" src="../../../../assets/image/medo-logo.png"> -->
            <h3 class="download-header">{{headerVal}}</h3>
        <hr>
        <div class="row" *ngIf="!url && !errorBool">
            <div class="col-md-2">
                <img width="50px" height="50px" src="../../../../assets/image/loader-icon.jpeg">
            </div>
            <div class="col-md-10" style="margin-top: 7px;padding: 19px">
                Downloading..., Please Wait
            </div>
        </div>
        <div class="row" *ngIf="url">
            <div class="col-md-2">
                <img width="35px" height="35px" src="../../../../assets/image/accept.png">
            </div>
            <div class="col-md-10" style="white-space: nowrap;">
                <span>Download Completed, <a href="javascript:;" (click)="download();">Download</a></span>
            </div>
        </div>
        <div class="row" *ngIf="errorBool">
            <div class="col-md-2">
                <img width="35px" height="35px" src="../../../../assets/image/cross.png">
            </div>
            <div class="col-md-10" style="margin-top: 10px;">
                Download Failed, Please try again
            </div>
        </div>
    </div>
</div>